module.exports = __webpack_public_path__ + "img/fx.b7a75328.png";